export const REVIEW_TABS = "review_tabs"
